var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg18",
    width: 1477.4399,
    height: 1057.1998,
    viewBox: "0 0 1477.4399 1057.1999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1057.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 549.133,2116.17 H 1977.6 v 605.82 H 1628.91 V 2466.17 H 1118.2 v 1302.76 h 218.81 v 349.79 H 549.133 V 3768.93 H 767.91 V 2466.17 H 549.133 v -350",
    style: {
      fill: "var(--background-color)"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3003.1,2095.1 c 572.07,0 1026.45,462.6 1026.45,1034.67 0,555.62 -462.57,1009.99 -1018.22,1009.99 -569.36,0 -1031.92,-451.6 -1031.92,-1026.44 0,-563.85 459.85,-1018.22 1023.69,-1018.22 m 0,372.26 c -361.32,0 -640.48,295.62 -640.48,656.9 0,358.61 290.15,643.24 645.96,643.24 350.37,0 637.76,-290.11 637.76,-640.48 0,-361.32 -279.21,-659.66 -643.24,-659.66",
    style: {
      fill: "var(--background-color)"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6817.01,4118.72 h -786.4 v -349.79 h 218.78 V 2466.17 h -218.78 v -350 h 786.4 v 350 h -217.65 v 1302.76 h 217.65 v 349.79",
    style: {
      fill: "var(--background-color)"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6889.75,2116.17 v 350 h 218.77 v 1302.76 h -218.77 v 349.79 h 1145.1 v -349.79 h -576.27 v -462.29 h 576.4 v -350.07 h -576.4 v -490.4 h 649.89 v 255.82 H 8457.7 V 2116.17 H 6889.75",
    style: {
      fill: "var(--background-color)"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7860.87,39.2891 h 888.45 c 294.51,0 530.1,72.9219 729.23,297.3009 171.06,190.699 258.02,443.148 258.02,698.34 0,277.66 -89.74,546.93 -283.26,743.25 -201.96,204.72 -417.9,263.65 -698.38,263.65 h -894.06 v -349.85 h 247.32 V 389.23 H 7860.87 Z M 8457.7,1691.98 h 252.37 c 185.1,0 333.76,-9.17 471.19,-149.4 123.42,-131.82 173.87,-328.12 173.87,-507.65 0,-162.668 -53.28,-347.762 -162.67,-473.961 -131.81,-151.457 -297.29,-176.707 -488,-176.707 H 8457.7 V 1691.98",
    style: {
      fill: "var(--background-color)"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1117.81,5885.6 h 291.91 v -281.13 h 349.86 v 631.07 H 125.121 V 5604.47 H 475 V 5885.6 H 767.449 V 4542.09 H 549.133 V 4192 h 787.877 v 350.09 h -219.2 V 5885.6",
    style: {
      fill: "var(--background-color)"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3234.58,5388.69 h -833 v 496.91 h 217.55 v 349.94 H 1832.8 V 5885.6 h 218.77 V 4542.09 H 1832.8 V 4192 h 786.33 v 350.09 h -217.55 v 496.52 h 833 V 4542.09 H 3015.75 V 4192 h 785.91 v 350.09 H 3585.71 V 5885.6 h 215.95 v 349.94 H 3015.75 V 5885.6 h 218.83 v -496.91",
    style: {
      fill: "var(--background-color)"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3874.88,4192 h 1619.77 v 605.82 H 5145.8 v -255.73 h -702.1 v 496.52 h 632.66 v 350.08 H 4443.7 v 496.91 h 704.35 v -253.1 h 348.85 v 603.04 H 3874.88 V 5885.6 h 218.77 V 4542.09 H 3874.88 V 4192",
    style: {
      fill: "var(--background-color)"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,7579.03 h 349.97 V 7929 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,7579.03 h 349.97 V 7929 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,7579.03 h 349.97 V 7929 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,7579.03 h 349.97 V 7929 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,7579.03 h 349.97 V 7929 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,7579.03 h 349.97 V 7929 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6837.95,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,7155.68 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,6732.32 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,6308.97 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,5885.61 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,5462.26 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,5038.91 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7261.3,4615.55 h 349.97 v 349.97 H 7261.3 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,4615.55 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7684.66,4192.2 h 349.97 v 349.97 H 7684.66 V 4192.2",
    style: {
      fill: "var(--background-color)"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path106"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,4615.55 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,4192.2 h 349.97 v 349.97 H 8108.01 V 4192.2",
    style: {
      fill: "var(--background-color)"
    },
    id: "path112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,3768.84 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path114"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8108.01,3345.49 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path120"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path122"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,4615.55 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8531.37,4192.2 h 349.97 v 349.97 H 8531.37 V 4192.2",
    style: {
      fill: "var(--background-color)"
    },
    id: "path132"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path136"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path138"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path140"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 8954.72,4615.55 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path156"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9378.07,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10648.1,6732.32 h 350 v 349.97 h -350 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path160"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10648.1,6308.97 h 350 v 349.97 h -350 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10648.1,5885.61 h 350 v 349.97 h -350 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path168"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9801.43,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10224.8,7155.68 h 349.9 v 349.97 h -349.9 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10224.8,6732.32 h 349.9 v 349.97 h -349.9 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path180"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10224.8,6308.97 h 349.9 v 349.97 h -349.9 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10224.8,5885.61 h 349.9 v 349.97 h -349.9 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10224.8,5462.26 h 349.9 v 349.97 h -349.9 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5991.24,7155.68 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5991.24,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5991.24,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5991.24,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5991.24,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path198"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path202"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,5462.26 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 6414.59,5038.91 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5567.88,6732.32 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5567.88,6308.97 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5567.88,5885.61 h 349.97 v 349.97 h -349.97 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 5114.58,2115.62 619.66,1652.58 h 219.96 v 349.98 h -447.5 l -3.46,1.28 -0.48,-1.28 H 5175.34 V 3768.2 h 196.19 L 4921.65,2568.41 4471.77,3768.2 h 203.46 v 349.98 h -334.68 l -0.49,1.28 -3.45,-1.28 H 3874.93 V 3768.2 h 234.14 l 619.66,-1652.58",
    style: {
      fill: "var(--background-color)"
    },
    id: "path214"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 7501.14,389.23 -276.58,398.36 c 58.48,28.191 113.69,67.5 166.69,121.539 127.11,124.261 194.91,296.581 194.91,474.541 0,209 -79.1,401.1 -248.61,525.41 -149.7,110.12 -355.89,132.75 -536.66,132.75 h -770.26 v -350.99 h 218.75 V 39.1484 h 571.26 V 389.23 H 6600.3 v 333.442 h 237.83 L 7319.25,39.2813 h 468.4 V 389.23 m -588.5,994.44 c 0,-93.23 -36.73,-183.61 -110.17,-245.76 -76.24,-64.95 -163.83,-67.8 -259.85,-67.8 H 6600.3 v 621.44 h 211.89 c 93.18,0 177.92,-2.8 259.85,-62.15 79.09,-53.67 127.11,-146.85 127.11,-245.73",
    style: {
      fill: "var(--background-color)"
    },
    id: "path216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 10657.3,1503.33 h 342.2 v 538.5 h -0.8 v 0.04 h -350 v -52.83 c -81.6,66.06 -188.3,94.86 -297.1,94.86 -322.5,0 -605.81,-246.81 -605.81,-577.79 0,-179.48 75.7,-330.94 218.78,-437.5 123.33,-92.571 246.83,-129.028 392.63,-171.098 154.2,-44.891 342.2,-95.352 342.2,-294.481 0,-171.101 -129.1,-274.859 -294.5,-274.859 -185.1,0 -297.3,140.226 -297.3,305.719 H 9759.79 V 388.09 h -0.14 V 38.1094 h 349.95 V 121.898 C 10200.2,38.7188 10316.4,0 10447,0 c 364.5,0 633.8,266.449 633.8,628.281 0,168.278 -70.1,316.91 -199.1,420.699 -129.1,98.16 -274.9,140.23 -429.1,182.29 -154.3,44.86 -328.2,86.92 -328.2,283.27 0,157.07 123.4,249.63 272.1,249.63 148.6,0 258,-112.21 260.8,-260.84",
    style: {
      fill: "var(--background-color)"
    },
    id: "path218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2071.32,38.1094 V 388.09 h -188.64 l -620.09,1653.74 -0.23,-0.09 v 0.09 H 549.133 V 1691.85 H 745.508 L 256.609,387.98 H 0 V 38.0117 h 488.008 l 0.062,-0.0312 0.012,0.0312 H 815.973 V 387.98 h -196.66 l 124,330.692 H 1396.03 L 1519.98,388.09 H 1316.09 V 38.1094 h 335.12 l 0.05,-0.1289 0.35,0.1289 z M 1264.8,1068.64 H 874.531 l 195.139,520.4 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6175.43,38.1094 V 388.09 h -149.16 l -620.1,1653.74 -0.22,-0.09 v 0.09 H 4699.17 V 1691.85 H 4889.1 L 4400.19,387.98 H 4143.58 V 38.0117 h 488.01 l 0.07,-0.0312 0.01,0.0312 h 327.89 V 387.98 h -196.67 l 124,330.692 h 652.72 L 5663.55,388.09 H 5459.67 V 38.1094 h 335.12 l 0.05,-0.1289 0.36,0.1289 z M 5408.38,1068.64 h -390.26 l 195.13,520.4 z",
    style: {
      fill: "var(--background-color)"
    },
    id: "path222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1629.61,1690.56 h 173.81 L 2423.08,37.9805 h 385.85 L 3086.08,777.129 3363.24,37.9805 h 385.85 L 4368.75,1690.56 h 257.08 v 349.97 h -484.62 l -3.46,1.3 -0.48,-1.3 h -327.42 v -349.97 h 196.19 l -449.88,-1199.79 -288.72,770.01 161.15,429.78 h 308.27 v 349.97 h -535.81 l -3.45,1.3 -0.49,-1.3 H 2869.7 v -349.97 h 196.18 L 2616,490.77 2166.13,1690.56 h 203.45 v 349.97 H 2034.9 l -0.49,1.3 -3.45,-1.3 h -401.35 v -349.97",
    style: {
      fill: "var(--background-color)"
    },
    id: "path224"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ba3b29ac89ce6c66632aed8ac01fff03.svg";
export { ForwardRef as ReactComponent };